<template>
  <v-layout
    row
    justify-center
  >
    <v-dialog
      v-model="orderInvoiceModal"
      persistent
      max-width="600px"
    >
      <v-card>
        <form @submit.prevent="submitForm()">
          <v-card-title>
            <div class="headline">
              Generate Invoice
            </div>
          </v-card-title>
          <v-card-text class="pt-0 px-4">
            <div class="row">
              <div class="col-12">
                <h5>Customer: {{ formData.customer_name }}</h5>
              </div>
              <div class="col-12">
                <h5>Phone number: {{ formData.phone }}</h5>
              </div>

              <div
                v-if="formData.orders && formData.orders.length > 0"
                class="col-12"
              >
                <h5>Orders</h5>
              </div>
              <div
                v-if="formData.orders && formData.orders.length > 0"
                class="col-12"
              >
                <ol>
                  <li
                    v-for="(order, index) in formData.orders"
                    :key="index"
                  >
                    <h6 style="display: inline-block">#{{ order.the_order_id }}</h6>

                    <i
                      class="fa fa-remove ml-4"
                      style="font-size: 16px; color: red; cursor: pointer"
                      @click="removeOrder(index)"
                    ></i>
                  </li>
                </ol>
              </div>

              <!-- <div class="col-12">
                <branch-select v-model="formData.branch_id_fk" />
              </div> -->

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Weight"
                  v-model="formData.weight"
                  :error-messages="errors.collect('Weight')"
                  v-validate="'required'"
                  data-vv-name="Weight"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Volume"
                  v-model="formData.volume"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Shipment"
                  v-model.number="formData.shipment"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Shipment')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Shipment"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Tax"
                  v-model.number="formData.tax"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Tax')"
                  v-validate="'decimal:2'"
                  data-vv-name="Tax"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Delivery price"
                  v-model.number="formData.delivery_price"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Delivery price')"
                  v-validate="'decimal:2'"
                  data-vv-name="Delivery price"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Total price"
                  v-model.number="formData.total_price"
                  readonly
                  :error-messages="errors.collect('Total price')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Total price"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Discount"
                  v-model.number="formData.discount"
                  @input="calculateTotalAmount()"
                  :error-messages="errors.collect('Discount')"
                  v-validate="'decimal:2'"
                  data-vv-name="Discount"
                />
              </div>

              <div class="col-12 col-sm-6">
                <v-text-field
                  label="Net price"
                  v-model.number="formData.net_price"
                  readonly
                  :error-messages="errors.collect('Net price')"
                  v-validate="'required|decimal:2'"
                  data-vv-name="Net price"
                />
              </div>

              <div class="col-12">
                <v-text-field
                  label="Paid amount"
                  v-model="formData.paid_amount"
                  :error-messages="errors.collect('Paid amount')"
                  v-validate="'decimal:2'"
                  data-vv-name="Paid amount"
                />
              </div>

              <div class="col-12">
                <v-text-field
                  label="Note"
                  v-model="formData.note"
                />
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn
              @click="$emit('close')"
              style="height:auto"
              outline
            >Cancel</v-btn>
            <v-btn
              type="submit"
              style="height:auto"
              outline
              color="primary"
            >Save</v-btn>
          </v-card-actions>
        </form>
      </v-card>
    </v-dialog>
  </v-layout>
</template>

<script>
import axios from 'axios'
import swal from 'sweetalert'

export default {
  props: ['orderInvoiceModal', 'formData'],

  data() {
    return {}
  },

  methods: {
    removeOrder(index) {
      this.formData.orders.splice(index, 1)
    },

    calculateTotalAmount() {
      let shipment = Number(this.formData.shipment) || 0
      let tax = Number(this.formData.tax) || 0
      let deliveryPrice = Number(this.formData.delivery_price) || 0
      let discount = Number(this.formData.discount) || 0

      this.formData.total_price = shipment + tax + deliveryPrice
      this.formData.net_price = this.formData.total_price - discount
    },

    submitForm() {
      // if (this.formData.orders.length === 0) {
      //   swal('Warning', 'Please at least select one order', 'error')
      //   return
      // }

      this.$validator.validateAll().then((res) => {
        if (res) {
          let token = localStorage.getItem('access_token')

          axios
            .post('api/order_invoice', this.formData, {
              headers: { Authorization: 'Bearer ' + token }
            })
            .then(() => {
              swal({
                title: 'Done',
                text: 'Invoice generated successfully',
                icon: 'success',
                timer: 1000,
                buttons: false
              })
              this.$emit('invoice-created')
              this.$emit('close')
            })
            .catch((err) => {
              swal('Warning', err.response.data.message, 'error')
            })
        }
      })
    }
  }
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}
.dialog {
  overflow-y: auto !important;
  overflow-x: hidden;
}
</style>



// WEBPACK FOOTER //
// src/components/orderInvoice/AddOrderInvoice.vue